
import Util from '@/assets/libs/util'
import requestModule from '../libs/requestModule'
import idxdDB from '@/assets/libs/IndexedDBController'
import moment from 'moment'
import router from '@/router'
import ProductController from './ProductController'
import PaymentController from './PaymentController'
import BalancaMode from '../../components/BalancaModeConfig/BalancaMode'

let updaterInterval = null
let waitingUpdate = false
let newImgOnlineBaseURL = ''
let newProducts = []
let newProductsList = null
let newPaymentsMethods = []
let newPaymentsLayout = []
let newDefaultParams = []
let newConfig = Util.getLocalVar('taaconfig')
let newSuggestions = {}

const updatePaymentsTypes = async function (config = null) {
    /* Atualiza os métodos de pagamento */
    let result = true
    if (config) {
        newConfig = config
        result = await updateNewPayments(config)
    }
    if (newPaymentsMethods.length > 0) {
        newConfig.tiposRecebimento = newPaymentsMethods
    }

    if (newPaymentsLayout.length > 0) {
        newConfig.metodosPagamento = newPaymentsLayout
    }

    if (config) setNewConfig()
    return result
}

const updateDefaultConfigs = async function () {
    /* Atualiza todas as informações de caixa presentes na tela de configuração do retail */
    if (!newConfig) return false
    if (!newDefaultParams || !newDefaultParams.length) await getNewDefaultParams() // busca as configurações de customizacao de caixa
    newConfig.lastTimeUpdatedConfig = moment().format('DD/MM/YYYY HH:mm:ss')
    let key = newConfig.filialCodigo + newConfig.lojaCodigo + newConfig.caixaCodigo
    newDefaultParams = (newDefaultParams && newDefaultParams.posConfigs && newDefaultParams.posConfigs[key]) || (newDefaultParams && newDefaultParams.generalConfigs)
    let images = (newDefaultParams && newDefaultParams.customMediaInfo) || null
    if (images) {
        await updateTaaImages(images)
    }
    let colors = (newDefaultParams && newDefaultParams.coresInfo) || null
    const defaultColors = {
        'primary_color': '#ff6821',
        'primary_light': '#ff9a51',
        'primary_dark': '#c43600',
        'header_color': '#f8601a',
        'categorie_color': '#ffffff',
        'categorie_font_color': '#1e1f1f',
        'cart_color': '#e2e1e1',
        'cart_font_color': '#1e1f1f',
        'price_font_color': '#ff0000'
    }
    if (colors && checkHasConfigsRetail(null, colors)) {
        colors = getDefaultColorsParams(colors)
        Object.keys(defaultColors).forEach((e) => {
            newConfig[e] = colors[e] || newConfig[e] || defaultColors[e]
        })
    }
    let configs = (newDefaultParams && newDefaultParams.configInfo) || null
    if (configs && checkHasConfigsRetail(configs, null)) {
        Object.keys(configs).forEach(c => {
            if (c === 'modeloImpressora' || c === 'portaImpressora' || c === 'modotap') {
                return
            }
            const languages = {'idiomaAdic_pt_br': 'pt_br', 'idiomaAdic_en': 'en', 'idiomaAdic_es': 'es'}
            if (languages[c] && configs[c] === true) {
                newConfig[c] = [languages[c]]
                return
            }
            newConfig[c] = configs[c]
        })
        if (configs.useAlternativeLayout === true) {
            newConfig.utiliza_layout_gom = true
            newConfig.slimMode = false
            newConfig.itemsList = false
        } else {
            newConfig.utiliza_layout_gom = false
        }
        if (!configs.comprimentoNSU) {
            newConfig.comprimentoNSU = 0
        }
    }
    if (Util.isGertecSk210()) {
        newConfig.modeloImpressora = 300
        newConfig.nomeImpressora = 'SK210'
    }
    newConfig.useAlternativeLayout = true
    newConfig.permiteObsDigitada = false
    return true
}

const updatePosConf = async function (config = null, force = false) {
    // if (force) await getNewDefaultParams()
    /* Atualiza as informações do caixa que vem na getPosTefData */
    if (config) newConfig = config
    if (!newConfig || !newConfig.filialCodigo) return false
    newConfig.curtaa = await requestModule.postRequest('menu/getPosTefData', {storeCode: newConfig.lojaCodigo, subsidiaryCode: newConfig.filialCodigo, posCode: newConfig.caixaCodigo}).then(e => {
        if (e.error) {
            Util.showInfoModal(e.message, true)
            return []
        }

        let result = e.data.posTefData.filter(c => newConfig.caixaCodigo === c.posCode)
        if (result && result.length > 0) {
            result[0].olgaTech = e.data.olgaTech || ''
            result[0].dtPortariaNfce = e.data.dtPortariaNfce || ''
            result[0].fixeCrm = e.data.fixeCrm || null
            result[0].blockCnpjPdv = e.data.blockCnpjPdv || 'N'
            result[0].autoOpenCommand = e.data.autoOpenCommand || 'N'
        }

        return result
    }).catch(e => {
        return false
    })
    if (!newConfig.curtaa || (newConfig && !newConfig.curtaa[0])) {
        console.log('Falha ao atualizar informações do caixa')
        return false
    }

    let curTaa = newConfig.curtaa && newConfig.curtaa[0]
    newConfig.curtaa = curTaa
    newConfig.lojaCodigo = curTaa.storeCode
    newConfig.nomeDoDispositivo = curTaa.posName
    newConfig.storeCNPJ = curTaa.storeCNPJ
    newConfig.orgMode = curTaa.orgMode || ''
    newConfig.tefCnpjHouse = curTaa.tefCnpjHouse
    newConfig.caixaCodigo = curTaa.posCode
    newConfig.enderecoIPTEF = curTaa.ipSiTef
    newConfig.codigoTerminalTEF = curTaa.tefCode
    newConfig.codLojaTEF = curTaa.storeTefCode
    newConfig.sendingCupEmail = curTaa.sendingCupEmail === 'S'
    newConfig.askPhoneNumber = curTaa.askPhoneNumber === 'S'
    newConfig.companyCodCRM = curTaa.companyCodCRM || ''
    newConfig.authCRM = curTaa.authCRM || ''
    newConfig.apiUrlCRM = curTaa.apiUrlCRM || ''
    newConfig.apiUrlCashback = curTaa.apiUrlCashback || ''
    newConfig.fixeCrm = curTaa.fixeCrm || null
    newConfig.useDigitalPager = (curTaa.useDigitalPager && curTaa.useDigitalPager) === 'S' || false
    newConfig.fidelityGcom = curTaa.fidelityGcom || null
    newConfig.tefEndProxy = curTaa.tefEndProxy || ''
    newConfig.tefProxyType = curTaa.tefProxyType || ''
    newConfig.tefToken = curTaa.tefToken || ''
    newConfig.tefCommunic = curTaa.tefCommunic || ''
    newConfig.orgEnv = curTaa.orgEnv || null
    newConfig.orgType = curTaa.orgType || null
    newConfig.infoConsTaa = curTaa.infoConsTaa === 'S'
    newConfig.lockKeyboardCons = curTaa.lockKeyboardCons === 'S'
    newConfig.printBalanceCons = curTaa.printBalanceCons || null
    newConfig.modotap = curTaa.posType === 'APC'
    newConfig.exibQrCodePinPad = curTaa.qrcodeOnPinpad === 'S'
    newConfig.imprimeTefReduzido = curTaa.reducedTefPrint === 'S'
    newConfig.olgaTech = curTaa.olgaTech || ''
    newConfig.dtPortariaNfce = curTaa.dtPortariaNfce || ''
    newConfig.hasTurnstile = curTaa.hasTurnstile === 'S'
    newConfig.idSolDigCons = curTaa.idSolDigCons && curTaa.idSolDigCons === 'S'
    newConfig.blockCnpjPdv = curTaa.blockCnpjPdv && curTaa.blockCnpjPdv === 'S'
    newConfig.allowComplement = curTaa.allowComplement && curTaa.allowComplement !== 'N'
    newConfig.autoOpenCommand = curTaa.autoOpenCommand === 'S'
    if (!Util.isGertecSk210() && !Util.isTectoy()) {
        newConfig.portaImpressora = (curTaa.printerConfigs && curTaa.printerConfigs.port) || (curTaa.printerConfigs && curTaa.printerConfigs.ip) || ''
        newConfig.modeloImpressora = (curTaa.printerConfigs && curTaa.printerConfigs.ModelCode) || ''
        newConfig.printerCode = (curTaa.printerConfigs && curTaa.printerConfigs.printerCode) || ''
        newConfig.nomeImpressora = (curTaa.printerConfigs && curTaa.printerConfigs.printerName) || ''
    }

    if (newConfig.modobalanca) {
        let weighed = await BalancaMode.loadData()
        let prodsWeighed = newConfig.weighed || []
        if (prodsWeighed && prodsWeighed.length > 0 && weighed && weighed.length > 0) {
            weighed.forEach((p) => {
                let idx = prodsWeighed.findIndex(e => e.productCode === p.productCode)
                if (idx !== -1) {
                    prodsWeighed[idx] = p
                }
            })
        }
    }

    Util.setLocalVar('modoentrega', (newConfig.modeEntrega && newConfig.modeEntrega.length === 1) ? newConfig.modeEntrega[0] : (newConfig.modeEntregaDrive && newConfig.modeEntregaDrive.length) ? 'drive' : null)
    let handleTask = true
    if (process.env.NODE_ENV !== 'production') {
        await Util.showConfirmationDialogSync(null, () => {
            handleTask = true
        }, 'Sincronizar configurações com o Retail?', () => {
            handleTask = false
        })
    }
    if (handleTask) {
        await updateDefaultConfigs()
    }
    if (config) setNewConfig()
    return true
}

const getDefaultColorsParams = function (coresInfo) {
    let result = {}
    Object.keys(coresInfo).forEach((e) => {
        let name = getNameParams(e, 'color')
        if (!name) { return }
        result[name] = tColorToHex(coresInfo[e])
    })
    return result
}

const tColorToHex = function (tColor) {
    const r = tColor & 0xFF
    const g = (tColor >> 8) & 0xFF
    const b = (tColor >> 16) & 0xFF
    return rgbToHex([r, g, b])
}

const rgbToHex = function (rgb) {
    const r = rgb[0]
    const g = rgb[1]
    const b = rgb[2]
    return '#' + ((1 << 24) + (Math.floor(r) << 16) + (Math.floor(g) << 8) + Math.floor(b)).toString(16).slice(1)
}

const updateTaaImages = async (images) => {
    const androidMode = Util.isAndroidMode()
    // const isGertecSk210 = Util.isGertecSk210()
    const isTectoy = Util.isTectoy()
    const db = await idxdDB.getImageDB()
    let imagesObj = await idxdDB.getImagesSIsFromDb(db)
    await idxdDB.deleteImagesSIFromDb()
    if (!imagesObj) {
        imagesObj = {}
    }
    Object.keys(images).forEach((e) => {
        let idx = getNameParams(e, 'img')
        if (!idx) return
        let updateImage = idx && (!imagesObj[idx] || imagesObj[idx].origin !== 'local') && (images[e] !== fileToExclude())
        let isvideo = isVideo(images[e])
        let fileAllowed = (
            (!isvideo) ||
            (!isTectoy) || // Android Gertec → permite vídeos
            (androidMode && isTectoy && isvideo === false) // Android não Gertec → permite só se não for vídeo
        )
        // let fileAllowed = ((!androidMode || !isGertecSk210) && isvideo !== null) || (androidMode && isvideo === false)
        if (updateImage && fileAllowed) {
            imagesObj[idx] = {
                image: images[e],
                origin: 'retail'
            }
        }
    })
    imagesObj.lastSync = moment().format('DD/MM/YYYY - HH:mm:ss')
    await updateStoredImages()
    return idxdDB.addImagesSIToDb(imagesObj, db).then(() => {
        return {
            error: false,
            images: imagesObj
        }
    }).catch(e => {
        return {
            error: true,
            message: e
        }
    })
}

const getNameParams = function (name, type) {
    const nameImages = {
        'IMGTELADEESPERA': 'espera',
        'IMGLOGO': 'logo',
        'PRODSEMFOTO': 'noImage',
        'INSTRUCOESPAGER': 'pager',
        'INSTRUCOESBALANCA': 'balancascreen',
        'INSTRUCOESTAP': 'tapscreen',
        'INSTRUCOESMAQUININHA': 'maquininha',
        'INSTRUCOESIMPRESSORA': 'impressora',
        'ERROIMPRESSORA': 'erroImpressora',
        'ERROSALVARVENDA': 'erroSalvarVenda',
        'ERROPINPAD': 'erroTEF',
        'ERROPINPAD2': 'erroPinpad',
        'LEVAR': 'toGo',
        'CONSLOCAL': 'comerAqui'
    }
    const nameColors = {
        'DSCORPRIMARIA': 'primary_color',
        'DSCORPRIMARIASUAVE': 'primary_light',
        'DSCORPRIMARIAESCURA': 'primary_dark',
        'DSCORCABECALHO': 'header_color',
        'DSCORCATEGORIAS': 'categorie_color',
        'DSCORFONTECATEGORIAS': 'categorie_font_color',
        'DSCORFUNDOCARRINHO': 'cart_color',
        'DSCORFONTEPRECO': 'price_font_color'
    }
    if (type === 'img') {
        return nameImages[name] ? nameImages[name] : null
    }
    if (type === 'color') {
        return nameColors[name] ? nameColors[name] : null
    }
    return null
}

const isVideo = function (fileName) {
    let videos = ['mp4', 'mkv', 'webm']
    if (!fileName || (fileName && !fileName.includes('data'))) {
        return null
    }
    try {
        let ext = fileName.split('/')[1].split(';').shift()
        if (ext && videos.includes(ext)) {
            return true
        }
    } catch (e) {
        console.log(e)
        return null
    }
    return false
}

const fileToExclude = function () {
    return 'data:image/jpeg;base64,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'
}

const updateStoredImages = async function () {
    let db = await idxdDB.getImageDB()
    let storedImages = await idxdDB.getImagesSIsFromDb(db)
    if (storedImages) {
        Util.setStoredImages(storedImages)
    }
}

const checkHasConfigsRetail = function (newConfig, newColors) {
    const DEFAULT_RETAIL_CONFIGS = {
        'urlPerifericos': '', 'balancaport': '', 'boldPrice': false, 'mainLanguage': [{'name': '', 'code': ''}], 'idiomaAdic_pt_br': false, 'idiomaAdic_en': false, 'idiomaAdic_es': false, 'comprimentoNSU': null, 'shouldAutoClose': false, 'modeEntrega': [], 'modeEntregaDrive': [], 'modeloImpressora': '', 'portaImpressora': 'US', 'useAlternativeLayout': true, 'slimMode': false, 'modotap': false, 'modobalanca': false, 'isEditMode': false, 'exibeContinuarComprando': false, 'itemsList': false, 'hideGroupOnMax': false, 'avancagrupomax': false, 'enableProdBarCodeRead': false, 'acessibilidade': false, 'agruparnaimpressao': false, 'produtoSemfoto': true, 'exibApartir': false, 'removeConfirmImpressaoCupom': false, 'cardapioExpira': false, 'usePager': false, 'allowMultipleAdd': true, 'imprimeEspelho': true, 'enableSubgroups': true, 'permiteObsDigitada': false, 'fixedServiceTax': false, 'showMinPriceDifference': false, 'removTXServTap': false, 'aplicaTXServAt': false, 'impFichas': false, 'timeOut': 150, 'timeOutInModal': 30
    }
    const DEFAULT_RETAIL_COLORS = {
        'DSCORPRIMARIA': 263046,
        'DSCORPRIMARIASUAVE': 6262865,
        'DSCORPRIMARIAESCURA': 196687,
        'DSCORCABECALHO': 263046,
        'DSCORCATEGORIAS': 16777215,
        'DSCORFONTECATEGORIAS': 2039582,
        'DSCORFUNDOCARRINHO': 14803426,
        'DSCORFONTEPRECO': 255
    }
    if (newConfig && JSON.stringify(newConfig) === JSON.stringify(DEFAULT_RETAIL_CONFIGS)) {
        return false
    }
    if (newColors && JSON.stringify(DEFAULT_RETAIL_COLORS) === JSON.stringify(newColors)) {
        return false
    }
    if (!newConfig && !newColors) {
        return false
    }
    return true
}

const syncProdImages = async function (config = null) {
    config = config || Util.getLocalVar('taaconfig')
    const result = await requestModule.postRequest('menu/syncCachedImages', {subsidiaryCode: config.filialCodigo})
        .then(r => r)
        .catch(e => {
            return {
                error: true,
                message: e
            }
        })
    if (!result || result.error) {
        console.log(result)
        return false
    }
    console.log('Imagens Sincronizadas')
    return true
}

const makeProdRequest = async function (force = false, progressOptions = null) {
    if (Util.isOracle()) {
        let timeout = 20 * 60 * 1000
        return requestModule.postRequest('v3/menu/getByPosExFull', Util.getGeneralInfo(), 'parent', (timeout)).then(r => r && r.data && r.data)
    }
    const payload = Util.getGeneralInfo(force)
    if (progressOptions && progressOptions.reportProgress) {
        payload.reportProgress = true
        payload.progressStart = progressOptions.progressStart
        payload.progressEnd = progressOptions.progressEnd
    }
    return requestModule.postRequest('getcachedfoodmenu', payload)
}

const autoBlockTaxPendingProducts = async function () {
    const config = Util.getLocalVar('taaconfig')
    if (!config || !config.filialCodigo) return

    const subsidiaryCode = config.filialCodigo
    const storeCode = config.lojaCodigo

    const payload = { subsidiaryCode, storeCode }

    const result = await requestModule.postRequest('menu/taxValidation', payload).catch(() => null)

    if (!result || result.error) return

    const pending = (result.data && result.data.productsWithPending) || []
    const noTax = (result.data && result.data.productsWithoutTax) || []

    if (pending.length === 0 && noTax.length === 0) return

    let blockList = Util.getLocalVar('blockProds') || []
    let newBlocks = []

    const processProduct = (product, status) => {
        const code = product.productCode
        const name = product.productName

        if (!blockList.includes(code)) {
            blockList.push(code)
            newBlocks.push({ code, name, status })
        }
    }

    pending.forEach(p => processProduct(p, 'taxpending'))
    noTax.forEach(p => processProduct(p, 'notax'))

    if (newBlocks.length > 0) {
        Util.setLocalVar('blockProds', blockList)

        const productList = newBlocks.map(p => `${p.name} (${p.status === 'notax' ? 'sem imposto' : 'imposto pendente'})`).join(', ')

        // Gravacao no log refente ao bloqueio automatico de produtos com pendencia de imposto.
        await Util.logComunication(
            'autoBlockTaxPendingProducts',
            { subsidiaryCode, storeCode },
            `Produtos bloqueados automaticamente por pendências: ${productList}`
        )
    }
}

const updateAllInBackgroud = async function () {
    let isTimeToUpdate = (Util.isTimeToReloadFoodMenu() && !waitingUpdate && router.currentRoute.name !== 'Config')
    if (!isTimeToUpdate) {
        if (router.currentRoute.name === 'Config') stopUpdaterInterval()
        return false
    }
    waitingUpdate = true
    stopUpdaterInterval()
    await prepareNewUpdates()
    do {
        await Util.sleep(5000)
    } while (router.currentRoute.name !== 'WaitScreen' && router.currentRoute.name !== 'Config')

    if (router.currentRoute.name !== 'Config' && newProducts.length > 0) {
        await updatePaymentsTypes() // atualiza os recebimentos
        await updatePosConf() // atualiza as informações de caixa
        await updateMenu() // Atualiza o cardapio
        await updateNewSuggestions() // Atualiza as sugestões
        setNewConfig()
    }
    startUpdaterInterval()
    waitingUpdate = false
}

const startUpdaterInterval = async function () {
    updaterInterval = setInterval(updateAllInBackgroud, 10 * 60 * 1000) // 10
}

const stopUpdaterInterval = function () {
    clearInterval(updaterInterval)
    updaterInterval = null
}

const updateNewProducts = async function (force = null, progressOptions = null) {
    await syncProdImages()
    newProducts = await makeProdRequest(force, progressOptions).then((prods) => {
        prods = Util.isOracle() ? prods : ((prods && prods.data && prods.data.data) || (prods && prods.result)) || null
        if (prods) {
            if (prods.imgOnlineBaseURL) {
                newImgOnlineBaseURL = prods.imgOnlineBaseURL
            }
            prods = (Util.isOracle() ? prods.groups : (JSON.parse(prods).data.groups || [])).filter(cat => ((cat.subGroups && cat.subGroups.length > 0) || (cat.products && cat.products.length > 0 && cat.products.length === cat.products.map(p => p.productShowOnMenu === 'N').length)))
            newProductsList = Util.generateProdList(prods)
            return prods || []
        }
    }).catch(e => {
        console.log(e)
    })
}

const updateNewPayments = async function (config = null) {
    config = config || newConfig || Util.getLocalVar('taaconfig')
    config.metodosPagamento = []

    const params = {
        subsidiaryCode: config.filialCodigo,
        posCode: (config.curtaa && config.curtaa.posCode) || config.caixaCodigo
    }
    let resultOdhenInterface = await requestModule.postRequest('menu/getPayments', params)
        .then(e => e)
        .catch(e => { return {error: true, message: e} })

    if (!resultOdhenInterface || resultOdhenInterface.error) {
        console.log(resultOdhenInterface.message)
        return false
    }
    resultOdhenInterface = resultOdhenInterface.data
    if (resultOdhenInterface && resultOdhenInterface.payments) {
        // config.tiposRecebimento = resultOdhenInterface.payments
        newPaymentsMethods = resultOdhenInterface.payments
    }

    if (resultOdhenInterface && resultOdhenInterface.layout) {
        // config.metodosPagamento = resultOdhenInterface.layout
        newPaymentsLayout = resultOdhenInterface.layout
    }
    if (process.env.pagamento && config.homologPay && newPaymentsLayout.find(mp => mp.DSBUTTON === 'Débito Dev (Fake)')) {
        let homologPay = Object.values(process.env.pagamento)
        let cdtiporecehomolog = await requestModule.postRequest('getBaseConfig', {type: 'basic'})
            .then(confData => (confData && confData.cdtiporecehomolog) || '999')
            .catch(r => false)
        homologPay[0].CDTIPORECE = cdtiporecehomolog || '999'
        newPaymentsLayout = [].concat(newPaymentsLayout, homologPay)
    }
    // Util.setLocalVar('taaconfig', config)
    return true
}

const getNewDefaultParams = async function (config) {
    const generalInfo = config ? {subsidiaryCode: config.filialCodigo, storeCode: config.lojaCodigo, posCode: config.caixaCodigo} : Util.getGeneralInfo()
    // const generalInfo = config || Util.getGeneralInfo()
    newDefaultParams = await requestModule.postRequest('menu/getCustomTaaConfigurations', generalInfo).then(r => (r && r.data) || false)
    return newDefaultParams
}

const prepareNewUpdates = async function () {
    await updateNewProducts()
    await updateNewPayments()
    await getNewDefaultParams()
    await getNewSuggestions()
    await autoBlockTaxPendingProducts()
}

const setNewConfig = function () {
    Util.setLocalVar('taaconfig', newConfig)
    Util.setLocalStoredColors()
    Util.updateLastSync()
    Util.reloadcachedConfigs()
    PaymentController.updatePaymentMethods()
}

const updateMenu = async function (force = false, config = null, progressOptions = null) {
    if (force) await updateNewProducts(force, progressOptions)
    config = config || Util.getLocalVar('taaconfig')
    idxdDB.clearDB()
    if (!Util.isOracle()) {
        const nameFile = `cachedFoodMenu${config.caixaCodigo}.json`
        await requestModule.postRequest('purgecachebyname', { posCode: nameFile })
    }
    const db = await idxdDB.getDb()
    await idxdDB.deleteProdSIFromDb()
    if (newProducts && newProducts.length > 0) {
        await idxdDB.addProdSIToDb(newProducts, db).then(() => {
            ProductController.setProductsList(newProducts, newProductsList)
            if (newImgOnlineBaseURL) {
                Util.setLocalVar('imgOnlineBaseURL', newImgOnlineBaseURL)
            }
            return true
        }).catch(e => {
            console.log('falha ao atualizar o indexedDB')
            console.log(e)
            return false
        })
    }
    return true
}

const getNewSuggestions = async function () {
    const suggestions = await requestModule.postRequest('menu/suggestions', Util.getGeneralInfo())
        .then(r => r && r.data)
        .catch(e => {
            console.log(e)
            return false
        })
    // suggestions.error = true
    if (!suggestions || suggestions.error) {
        console.log(suggestions.message)
        return false
    }
    newSuggestions = suggestions
    return true
}

const updateNewSuggestions = async function (force = false) {
    if (force) await getNewSuggestions(force)
    const db = await idxdDB.getSuggestionsDB()
    await idxdDB.deleteSuggestionsSIFromDb()
    if (newSuggestions && typeof newSuggestions === 'object' && Object.keys(newSuggestions).length > 0) {
        try {
            await idxdDB.addSuggestionsSIToDb(newSuggestions, db)
            return true
        } catch (e) {
            console.log('falha ao atualizar sugestões no indexedDB')
            console.log(e)
            return false
        }
    }
    return true
}

const checkParams = async function (config) {
    const params = {
        subsidiaryCode: config.filialCodigo,
        storeCode: config.lojaCodigo,
        posCode: config.caixaCodigo
    }
    let result = await requestModule.postRequest('sale/validateGeneralParams', params).then(r => (r && r.data) || false)
    return result
}

const checkTaxPendingProducts = async function () {
    const config = Util.getLocalVar('taaconfig')
    if (!config || !config.filialCodigo) return { hasPending: false }

    const params = {
        subsidiaryCode: config.filialCodigo,
        storeCode: config.lojaCodigo
    }

    const result = await requestModule.postRequest('menu/taxValidation', params)
        .catch(() => null)

    if (!result || result.error) return { hasPending: false }

    const pending = (result.data && result.data.productsWithPending) || []
    const noTax = (result.data && result.data.productsWithoutTax) || []

    const blockList = Util.getLocalVar('blockProds') || []

    const unblocked = [
        ...pending.filter(p => !blockList.includes(p.productCode)),
        ...noTax.filter(p => !blockList.includes(p.productCode))
    ]

    return {
        hasPending: unblocked.length > 0,
        data: result.data
    }
}

const checkTaxValidation = async function (config) {
    const params = {
        subsidiaryCode: config.filialCodigo,
        storeCode: config.lojaCodigo
    }
    const result = await requestModule.postRequest('menu/taxValidation', params)
        .then(r => r)
        .catch(e => ({ error: true, message: e }))

    return result
}

if (process.env.NODE_ENV !== 'production') {
    window.__UpdaterController = {
        autoBlockTaxPendingProducts,
        updateAllInBackgroud
    }
}

export default {
    updatePaymentsTypes,
    syncProdImages,
    updateStoredImages,
    updateAllInBackgroud,
    startUpdaterInterval,
    stopUpdaterInterval,
    updateMenu,
    updatePosConf,
    getNewDefaultParams,
    checkHasConfigsRetail,
    checkParams,
    updateNewSuggestions,
    getNewSuggestions,
    checkTaxValidation,
    checkTaxPendingProducts,
    autoBlockTaxPendingProducts
}



// WEBPACK FOOTER //
// ./src/assets/controllers/UpdaterController.js